import React from "react";
import * as Mui from "@mui/material";
import HistoryOutlinedIcon from "@mui/icons-material/HistoryOutlined";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import { designColors, designRadii } from "services/constants/designTokens";

const normalizeAuditTrail = (source) => {
  const rawTrail = Array.isArray(source)
    ? source
    : source?.edit_audit_trail || source?.audit_trail || source?.auditTrail || [];

  return Array.isArray(rawTrail)
    ? rawTrail.filter((entry) => entry?.message || entry?.edited_by)
    : [];
};

const fallbackMessage = (entry) => {
  const actor = entry?.edited_by || entry?.changed_by || "Unknown";
  const editedAt = entry?.edited_at || entry?.changed_at || "-";
  const changedFields = Array.isArray(entry?.changed_fields)
    ? entry.changed_fields.join(", ")
    : entry?.changed_fields || entry?.changedFields || "Updated fields";

  return `Edited by ${actor} on ${editedAt} - ${changedFields}`;
};

export const ApprovalEditAuditTrail = ({ data, title = "Edit Audit" }) => {
  const trail = normalizeAuditTrail(data);

  if (!trail.length) return null;

  return (
    <Mui.Box
      sx={{
        border: `1px solid ${designColors.slate200}`,
        borderRadius: designRadii.card,
        backgroundColor: designColors.white,
        p: 1.75,
      }}
    >
      <Mui.Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1.25 }}>
        <Mui.Box
          sx={{
            width: 30,
            height: 30,
            borderRadius: 1,
            backgroundColor: "#EEF2FF",
            color: "#4F46E5",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <HistoryOutlinedIcon sx={{ fontSize: 18 }} />
        </Mui.Box>
        <Mui.Typography
          sx={{
            fontSize: 13,
            fontWeight: 700,
            color: designColors.slate800,
          }}
        >
          {title}
        </Mui.Typography>
      </Mui.Stack>
      <Mui.Stack spacing={0.9}>
        {trail.map((entry, index) => (
          <Mui.Stack
            key={`${entry?.edited_at || entry?.message || "audit"}-${index}`}
            direction="row"
            spacing={1}
            alignItems="flex-start"
            sx={{
              color: designColors.slate700,
              fontSize: 12.5,
              lineHeight: 1.45,
            }}
          >
            <EditOutlinedIcon
              sx={{ fontSize: 15, mt: 0.15, color: designColors.slate500 }}
            />
            <Mui.Typography sx={{ fontSize: 12.5, color: designColors.slate700 }}>
              {entry?.message || fallbackMessage(entry)}
            </Mui.Typography>
          </Mui.Stack>
        ))}
      </Mui.Stack>
    </Mui.Box>
  );
};

export default ApprovalEditAuditTrail;
